import type { BackendEnvironment } from '@core/environment-legacy';

export const RECRUITEE_BACKEND = (<const>{
  protocol: 'https',
  referralsProtocol: 'https',
  domain: 'api.s.recruitee.com',
  partialDomain: 's.recruitee.com',
  referralsPartialDomain: 's.referrals.co',
  apiUrl: 'https://api.s.recruitee.com',
  authUrl: 'https://auth.s.recruitee.com',
  appUrl: 'https://s.recruitee.com',
  webAppUrl: 'https://app.s.recruitee.com',
  mobileAppUrl: 'https://mobile.s.recruitee.com',
  wsUrl: 'wss://api.s.recruitee.com/socket',
  widgetUrl: 'https://recruitee.github.io/widget/demos/widget.js',
  widgetApiEndpoint: 'https://career.s.recruitee.com/api/c',
  videoAppUrl: 'https://video.s.recruitee.com',
  CDNHost: 'https://app.s.recruitee.com',
  pdfViewerDirectory: 'pdfjs-patched-staging',
  integrationsUrl: 'https://integrations.s.recruitee.com',
  tellentApiUrl: 'https://api.s.tellent.com',
  tellentAuthUrl: 'https://auth.s.tellent.com',
  tellentAppUrl: 'https://admin.s.tellent.com',
  tellentAppWsUrl: 'wss://api.s.tellent.com/socket',
}) satisfies BackendEnvironment;
